import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/CategoryGuests/Get`, payload),
    GetMoblie: (payload) => Repository.post(`/api/CategoryGuests/GetMoblie`, payload),
    GetBanner: (payload) => Repository.post(`/api/CategoryGuests/GetBanner`, payload),
    GetByGeoCode: (payload) => Repository.post(`/api/CategoryGuests/GetByGeoCode`, payload),

}
